import { render, staticRenderFns } from "./wisdomBarracks.vue?vue&type=template&id=a2600b2a&scoped=true&"
import script from "./wisdomBarracks.vue?vue&type=script&lang=js&"
export * from "./wisdomBarracks.vue?vue&type=script&lang=js&"
import style0 from "./wisdomBarracks.vue?vue&type=style&index=0&id=a2600b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2600b2a",
  null
  
)

export default component.exports